import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgCentrum = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <circle
      cx={20}
      cy={28}
      r={5}
      fill="#85E3F9"
    />
    <path
      fill="#00C5F2"
      d="M20 5c-4.95 0-9 3.902-9 8.705 0 1.901.65 3.702 1.8 5.203l6.8 8.905c.15.2.5.25.7.1l.1-.1 6.8-8.905c1.15-1.5 1.8-3.302 1.8-5.203C29 8.902 24.95 5 20 5"
    />
    <ellipse
      cx={20}
      cy={13.846}
      fill="#85E3F9"
      rx={3.6}
      ry={3.538}
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgCentrum);

export default ForwardRef;
